// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brb-checkbox[data-v-9c1b29f2] {\n  font-size: 1.125rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: transparent !important;\n  width: 100%;\n  border: 1px solid #3a3a3a;\n  border-radius: 1rem;\n  color: #3a3a3a;\n  height: 3.125rem;\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
